import Cookies from "js-cookie"

const COOKIE_KEY = "priceColumn"

export function getPriceColumn() {
  return Cookies.get(COOKIE_KEY) ?? "GB_price"
}

export function getPriceColumnFromServer(): string {
  if (typeof window !== "undefined") return getPriceColumn()
  const { cookies } = require("next/headers")
  return cookies().get(COOKIE_KEY)?.value ?? "GB_price"
}
